import * as React from 'react'
import BaseIcon from 'react-icon-base'

const LeaderBoardIcon = props => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#C4CCD5"
      strokeWidth="1.067"
      d="M15.466 1.688h-2.539l.018-.55c.007-.207.01-.408.011-.605H3.044c0 .199.004.4.011.604l.018.551H.533c.012 1.975.53 3.829 1.457 5.22.896 1.347 2.062 2.104 3.302 2.176l.215.012.147.16c.288.314.59.567.901.758l.254.157v2.914H5.49c-.655 0-1.19.535-1.19 1.191v1.19h7.402v-1.19c0-.656-.535-1.19-1.19-1.19H9.19V10.17l.254-.157c.31-.19.612-.444.901-.759l.146-.159.216-.012c1.24-.072 2.406-.829 3.302-2.176.926-1.391 1.445-3.245 1.456-5.22zM1.882 6.98C1.005 5.66.492 3.952.415 2.115L.39 1.559h2.676l.039.491c.165 2.083.652 3.992 1.402 5.49.117.235.24.458.37.67l.806 1.325-1.45-.548c-.896-.339-1.702-1.03-2.352-2.007zm0 0zm12.236 0c-.65.976-1.456 1.668-2.351 2.007l-1.452.548.808-1.325c.129-.211.252-.434.37-.67.749-1.498 1.236-3.406 1.401-5.49l.039-.491h2.676l-.024.556c-.077 1.837-.59 3.546-1.467 4.865z"
    />
  </BaseIcon>
)

export default LeaderBoardIcon
